import { Logo } from "./logo";

export function AppLoading() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <Logo />
      <div className="spinner-border text-primary mt-24pt" role="status">
        <span className="sr-only">Cargando...</span>
      </div>
    </div>
  );
}

export function SectionLoading() {
  return (
    <div className="card card-body text-center py-48pt">
      <div className="spinner-border text-primary mx-auto" role="status">
        <span className="sr-only">Cargando...</span>
      </div>
      <p className="text-50 mb-0 mt-16pt">Cargando informacion...</p>
    </div>
  );
}
